import geoConfig from 'Config/geos';
import array from './array';
import obj from './object';

const { flatten } = array;
const { swapKV } = obj;

export default function geosAsObject(swap = false) {
  const ret = flatten(geoConfig, 1).reduce(
    (acc, [key, val]) => ({ ...acc, [key]: val }),
    {}
  );
  return (swap) ? swapKV(ret) : ret;
}



// WEBPACK FOOTER //
// ./app/utils/geosAsObject.js